
<span :class="{ 'text-overflow-ellipsis': ellipsis }" v-html="text"></span>
